import { Divider, Grid, Stack, Typography } from '@mui/material'
import React from 'react'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import PropTypes from 'prop-types'
import AlertUI from '../../../generic/AlertUI'
import PausePart from '../pause/PausePart'
import { useDateFormatter } from '../../../generic/hooks/useDateFormatter'
import FinishJobButton from './FinishJobButton'
import { partResultLabel } from '../../../generic/utilities/partResultLabel'

// Import typedefs from another file
/**
 * @typedef {import('../../../generic/utilities/objectStructures/partWindow/part').PartHistoryHeader} PartHistoryHeader PartHistoryHeader object
 */

/**
 * @param {object} props props object
 * @param {PartHistoryHeader} props.part Part object
 */
const PartHistoryHeader = (props) => {
  const { t_ } = useSmartTranslation()
  const { formatDate } = useDateFormatter()
  const [AlertElement, showAlert] = AlertUI()

  const leftAlignStyle = {
    textAlign: 'left'
  }

  const dividerStyle = {
    marginBottom: '0.5rem',
    marginTop: '0.5rem'
  }

  const typographyValueStyle = {
    marginLeft: '0.5rem'
  }

  const divFlexStyle = {
    display: 'flex'
  }

  return (
    <div style={leftAlignStyle}>
      {AlertElement}
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Typography variant='h4' style={{ textAlign: 'left' }}>{t_('Part').toUpperCase()}</Typography>
        <Stack direction='row' gap={1}>
          <FinishJobButton part={props.part} />
          <PausePart part={props.part} showAlert={showAlert} />
        </Stack>
      </Stack>
      <Divider style={dividerStyle} />
      <Grid container direction='row' spacing={2} columns={{ xs: 1, sm: 4, md: 8, lg: 14 }} style={{ marginLeft: '1rem' }}>
        <Grid item xs={3}>
          <div style={divFlexStyle}>
            <Typography>{t_('Code')}:</Typography>
            <Typography color='grey' style={typographyValueStyle}>{props.part.code}</Typography>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div style={divFlexStyle}>
            <Typography>{t_('Name')}:</Typography>
            <Typography color='grey' style={typographyValueStyle}>{props.part.name}</Typography>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div style={divFlexStyle}>
            <Typography>{t_('Description')}:</Typography>
            <Typography color='grey' style={typographyValueStyle}>{props.part.description}</Typography>
          </div>
        </Grid>
        <Grid item xs={4}>
          <div style={divFlexStyle}>
            <Typography>{t_('Raw Material Reference')}:</Typography>
            <Typography color='grey' style={typographyValueStyle}>{props.part.rawMaterialReferenceName}</Typography>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div style={divFlexStyle}>
            <Typography>{t_('Status')}:</Typography>
            <Typography color='grey' style={typographyValueStyle}>
              {t_(props.part.status)}
            </Typography>
          </div>
        </Grid>
        {/* S36 (P4/D7): the result is its own datum next to Status, painted exactly as Sun
            publishes it (RN8.1/INV6) -- never derived from status here either. The action
            buttons above (FinishJobButton/PausePart) keep reading part.status/pseudo-states on
            their own; this addition does not touch them. */}
        <Grid item xs={3}>
          <div style={divFlexStyle}>
            <Typography>{t_('Result')}:</Typography>
            <Typography color='grey' style={typographyValueStyle}>
              {partResultLabel(props.part.result, t_)}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div style={divFlexStyle}>
            <Typography>{t_('FO')}:</Typography>
            <Typography color='grey' style={typographyValueStyle}>{props.part.fabricationOrder}</Typography>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div style={divFlexStyle}>
            <Typography>{t_('Delivery date')}:</Typography>
            <Typography color='grey' style={typographyValueStyle}>{formatDate(props.part.deliveryDate)}</Typography>
          </div>
        </Grid>
      </Grid>
      <Divider style={dividerStyle} />
    </div>
  )
}

export default PartHistoryHeader

PartHistoryHeader.propTypes = {
  /**
   * Part object
   */
  part: PropTypes.object.isRequired

}
